/* Density preference — comfortable (default) / compact.
   Compact only takes effect on pointer:fine devices; the CSS media
   query in tokens.css enforces the ≥44px touch floor.
   Persisted in localStorage.  No server contract — pure UI. */
import * as React from "react";

const STORAGE_KEY = "fable.density";
const DEFAULT = "comfortable";

export function useDensity() {
  const [density, _setDensity] = React.useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || DEFAULT;
    } catch {
      return DEFAULT;
    }
  });
  React.useEffect(() => {
    document.documentElement.setAttribute("data-density", density);
  }, [density]);
  const setDensity = React.useCallback((next) => {
    _setDensity(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {}
  }, []);
  return { density, setDensity };
}
